import type { PaymentInfo } from '@festina/moneyin-general-types/moneyin'
import { stringUtils } from '@festina-life/core'
import { RawCheckbox } from '@festina-life/ui/forms'
import { createColumnDefiner } from '@festina-life/ui/listsAndTables'

import { usePaymentsTableColumns } from '../pages/payments/usePaymentsTableColumns'

export const isMatchable = (
  paymentStatus: PaymentInfo['paymentStatus'],
): boolean =>
  // Negated on-closed so that if new unknown statuses are configured, they can at least be selected.
  !stringUtils.strictIncludes(paymentStatus, ['closed'])

type Props = {
  isReadOnly?: boolean
  paymentsSelectedForAttach?: PaymentInfo[]
  onPaymentSelectedForAttach?: (payment: PaymentInfo) => void
}

const defineColumn = createColumnDefiner<PaymentInfo>()

export const usePaymentInfoTableColumns = ({
  isReadOnly,
  paymentsSelectedForAttach,
  onPaymentSelectedForAttach,
}: Props) => {
  const commonColumns = usePaymentsTableColumns()

  return {
    ...(isReadOnly
      ? {}
      : {
          selected: defineColumn({
            heading: undefined,
            keyPath: undefined,
            formatter: (payment) =>
              isMatchable(payment.paymentStatus) ? (
                <RawCheckbox
                  checked={
                    paymentsSelectedForAttach?.some(
                      (p) => p.paymentId === payment.paymentId,
                    ) ?? false
                  }
                  onChange={() => onPaymentSelectedForAttach?.(payment)}
                  onClick={(event) => event.stopPropagation()}
                />
              ) : null,
          }),
        }),
    ...commonColumns,
  }
}
